const carouselItems = [
  {
    title: '古装传奇巅峰',
    subtitle: '长安如故',
    desc: '年度口碑古装巨制，48集全剧情完整上线',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20ancient%20Chinese%20palace%20scene%20in%20warm%20golden%20sunset%20light%2C%20traditional%20architecture%20with%20flowing%20red%20silk%20banners%2C%20elegant%20lanterns%2C%20atmospheric%20haze%2C%20rich%20red%20and%20gold%20tones%2C%20no%20people%2C%20historical%20drama%20epic%20aesthetic&width=700&height=420&seq=wuma-carousel-01&orientation=landscape',
  },
  {
    title: '暑期必追悬疑',
    subtitle: '深渊之光',
    desc: '32集烧脑刑侦大戏，每集反转意想不到',
    image: 'https://readdy.ai/api/search-image?query=A%20moody%20noir%20urban%20scene%20with%20rain-slicked%20streets%20and%20neon%20reflections%2C%20deep%20shadows%2C%20foggy%20alleyway%2C%20mysterious%20atmosphere%2C%20cool%20blue%20accents%20against%20warm%20street%20lamps%2C%20no%20people%2C%20detective%20noir%20cinematic&width=700&height=420&seq=wuma-carousel-02&orientation=landscape',
  },
  {
    title: '都市情感力作',
    subtitle: '星辰大海',
    desc: '36集温暖治愈都市剧，豆瓣高分口碑推荐',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20modern%20city%20skyline%20at%20twilight%20with%20soft%20pink%20and%20gold%20sky%2C%20city%20lights%20glowing%2C%20gentle%20bokeh%20effect%2C%20romantic%20urban%20vibe%2C%20no%20people%2C%20emotional%20drama%20aesthetic%2C%20warm%20tones&width=700&height=420&seq=wuma-carousel-03&orientation=landscape',
  },
  {
    title: '玄幻视觉盛宴',
    subtitle: '九州风云录',
    desc: '国产玄幻天花板级特效，40集持续更新中',
    image: 'https://readdy.ai/api/search-image?query=An%20epic%20fantasy%20landscape%20with%20floating%20islands%20and%20ancient%20temples%2C%20golden%20light%20rays%20piercing%20through%20dramatic%20clouds%2C%20mystical%20atmosphere%2C%20warm%20amber%20tones%2C%20no%20people%2C%20grand%20fantasy%20cinematic%20scale&width=700&height=420&seq=wuma-carousel-04&orientation=landscape',
  },
  {
    title: '经典年代情怀',
    subtitle: '岁月如歌',
    desc: '42集温情年代剧，重温那些难忘的时光记忆',
    image: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20vintage%20scene%20with%20warm%20sunlight%20through%20old%20windows%2C%20traditional%20Chinese%20courtyard%2C%20soft%20sepia%20tones%2C%20peaceful%20atmosphere%2C%20wooden%20furniture%2C%20no%20people%2C%20sentimental%20period%20drama%20aesthetic&width=700&height=420&seq=wuma-carousel-05&orientation=landscape',
  },
  {
    title: '韩剧引进热潮',
    subtitle: '黑暗荣耀',
    desc: 'Netflix现象级韩剧全集上线，复仇剧情高能不断',
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20modern%20Korean%20drama%20aesthetic%20scene%20with%20elegant%20interior%2C%20soft%20dramatic%20lighting%2C%20contrast%20shadows%2C%20minimalist%20luxury%20vibe%2C%20warm%20and%20cool%20tone%20blend%2C%20no%20people%2C%20contemporary%20cinematic%20look&width=700&height=420&seq=wuma-carousel-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950 mb-3">
            热门专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            精选当前最受关注的电视剧，点击探索更多精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item, index) => (
            <div
              key={index}
              className="group relative rounded-2xl overflow-hidden cursor-pointer bg-background-200"
            >
              <div className="aspect-[5/3] relative overflow-hidden">
                <img
                  src={item.image}
                  alt={`午马影院 - ${item.subtitle}`}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-background-950/20 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <span className="inline-block px-2 py-0.5 text-[10px] md:text-xs font-medium text-primary-500 bg-primary-500/10 rounded-full mb-2 whitespace-nowrap">
                  {item.title}
                </span>
                <h3 className="text-base md:text-lg font-bold text-foreground-50 mb-1">
                  {item.subtitle}
                </h3>
                <p className="text-xs md:text-sm text-foreground-300 line-clamp-1">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}